define("shared/components/shared/wizard/slide/footer", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <@modal.card-footer>
    {{#if (has-block)}}
      {{yield}}
    {{else}}
      {{@slideCount}}
      <div class="o--btnBar">
  
        {{@cancelButton isFirstSlide=@isFirstSlide onCancel=@onCancel text=@cancelButtonText}}
        {{@previousButton isFirstSlide=@isFirstSlide text=@previousButtonText}}
        {{@nextButton isDisabled=@isDisabled isLastSlide=@isLastSlide onClick=@onClick text=@nextButtonText}}
        {{@finishButton isDisabled=@isDisabled isLastSlide=@isLastSlide onClick=@onClick text=@finishButtonText}}
  
      </div>
    {{/if}}
  </@modal.card-footer>
  */
  {
    "id": "Z9qrKUd0",
    "block": "[[[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[48,[30,16]],[[[1,\"    \"],[18,16,null],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[30,2]],[1,\"\\n    \"],[10,0],[14,0,\"o--btnBar\"],[12],[1,\"\\n\\n      \"],[1,[28,[30,3],null,[[\"isFirstSlide\",\"onCancel\",\"text\"],[[30,4],[30,5],[30,6]]]]],[1,\"\\n      \"],[1,[28,[30,7],null,[[\"isFirstSlide\",\"text\"],[[30,4],[30,8]]]]],[1,\"\\n      \"],[1,[28,[30,9],null,[[\"isDisabled\",\"isLastSlide\",\"onClick\",\"text\"],[[30,10],[30,11],[30,12],[30,13]]]]],[1,\"\\n      \"],[1,[28,[30,14],null,[[\"isDisabled\",\"isLastSlide\",\"onClick\",\"text\"],[[30,10],[30,11],[30,12],[30,15]]]]],[1,\"\\n\\n    \"],[13],[1,\"\\n\"]],[]]]],[]]]]]],[\"@modal\",\"@slideCount\",\"@cancelButton\",\"@isFirstSlide\",\"@onCancel\",\"@cancelButtonText\",\"@previousButton\",\"@previousButtonText\",\"@nextButton\",\"@isDisabled\",\"@isLastSlide\",\"@onClick\",\"@nextButtonText\",\"@finishButton\",\"@finishButtonText\",\"&default\"],false,[\"if\",\"has-block\",\"yield\"]]",
    "moduleName": "shared/components/shared/wizard/slide/footer.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});